module.exports = __webpack_public_path__ + "static/img/printbox.45a22de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/printbox.png
// module id = bj86
// module chunks = 0